module.exports = __webpack_public_path__ + "static/media/about-3.44e1602b.png";